import { NgModule } from '@angular/core';
import { NgxPrintModule } from 'ngx-print';
import { CoreUiModule } from 'webcommon/core-ui';
import { FindControlModule } from 'webcommon/find-control';
import { MacroModule } from 'webcommon/macro';
import { HtmlEditorModule } from 'webcommon/html-editor';
import { MessagesModule } from 'webcommon/messages';
import { APFacilityPortalComponent } from './ap-facility-portal/index';
import {
  FPAppointmentPrintContentComponent,
  FPAppointmentResultsComponent,
  FPAppointmentsComponent,
} from './fp-appointments/index';
import {
  APFacilityPortalConfigurationComponent,
  FPConfigurationModalComponent,
} from './fp-configuration/index';
import { FPContentHostDirective, FPDocumentPrintingComponent } from './fp-document-printing/index';
import {
  FPMessageComponent,
  FPMessageCountsComponent,
  FPMessageCreateModalComponent,
  FPMessageReceivedComponent,
  FPMessageReplyComponent,
  FPMessageReplyModalComponent,
} from './fp-message/index';
import { FPIncludeArchivedMessagesPipe } from './fp-pipes/index';
import { FpSearchComponent } from './fp-search/index';
import { FPShellComponent } from './fp-shell/index';

const ajsComponents = [
  APFacilityPortalComponent,
];

const modalComponents = [
  FPAppointmentPrintContentComponent,
  FPMessageCreateModalComponent,
  FPMessageReplyModalComponent,
];

const exportComponents = [
  ...ajsComponents,
  APFacilityPortalConfigurationComponent,
  FPMessageReplyComponent,
  FPContentHostDirective,
];

const declareComponents = [
  ...exportComponents,
  ...modalComponents,
  FPAppointmentResultsComponent,
  FPAppointmentsComponent,
  FPConfigurationModalComponent,
  FPDocumentPrintingComponent,
  FPIncludeArchivedMessagesPipe,
  FPMessageComponent,
  FPMessageCountsComponent,
  FPMessageCreateModalComponent,
  FPMessageReceivedComponent,
  FpSearchComponent,
  FPShellComponent,
];

@NgModule({
  declarations: [
    ...declareComponents,
  ],
  exports: [
    exportComponents,
  ],
  imports: [
    CoreUiModule,
    FindControlModule,
    NgxPrintModule,
    MacroModule,
    MessagesModule,
    HtmlEditorModule,
  ],
})
export class FacilityPortalModule {
}
